// Add your custom JS here.

gsap.registerPlugin(ScrollTrigger);

let revealContainers = document.querySelectorAll(".img-container");
let rule = CSSRulePlugin.getRule(".img-container:after");

revealContainers.forEach((container) => {
  let image = container.querySelector("img");
  
  let tl = gsap
      .timeline({
          scrollTrigger: {
              trigger: container,
              markers: false,
              toggleActions: "restart none none reset",
          },
      })

      .to(container, { duration: 1, "--height": "100%", ease: "Power2.ease" })
      .to(container, { duration: 1, "--height": "0%", ease: "Power2.ease" })
      .to(image, { duration: 0.2, opacity: 1, delay: -1 })
      .from(image, {
          duration: 1.25,
          scale: 1.75,
          ease: "sine.out",
		  y: window.innerWidth > 768 ? -500 : 0,
          delay: -1.2,
      });
  
});
